// extracted by mini-css-extract-plugin
export default {"root":"RegionMenuModal_root__XOLzO"};